<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$t('PharmacyNotes.Title')"
            :width="'50%'"
            :height="'450px'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK,disabled:!pendingChanges },                   
            ]"              
            @close="close"
            @hide="hide"
        >
            <b-row>
                <b-col lg="12" md="12" sm="12">
                    <MdSelect
                        v-bind:Label="$t('PharmacyNotes.Intervention')"
                        v-bind:Options="noteTypeList"
                        v-bind:ModelArray="noteTypeVModel"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'value'"
                        :Input="changeDropDownNoteType"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="12" md="12" sm="12">
                    <MdMemo
                        v-bind:Name="'comments'"
                        v-bind:Rows="'14'"
                        v-bind:MaxRows="'14'"           
                        v-model="comments"                       
                    />
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import EnumService from "@/services/enum.service"
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';
import MedicationService from '@/services/medication.service'
import { EventBus } from '@/event-bus.js';

export default {
    name: 'DrugOrderNotesDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        item: Object,
        editable: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            pendingChanges: false,
            modalId: 'ItemsRemovalEditDlgId',
            noteTypeVModel: {name: '', value: ''},
            comments: null,
            noteTypeList: EnumService.DrugOrderTypeNote
        }
    },

    watch: {
        visible(newVal) {
            this.noteTypeVModel = {name: '', value: ''};
            if (newVal) {
                this.emitCloseEvent= true;
                this.comments = null;
            }
        },
        item(newVal) {
            if (newVal) {
                this.comments = null;
                /*if (this.editable) {
                    this.item = newVal;
                    this.loadComments();
                }*/
               this.loadComments();
            }
        }
    },

    created(){       
      
    },

    beforeDestroy(){
        EventBus.$off('onChanged');
    },

    mounted(){
        EventBus.$on("onChanged", function () {   
            this.pendingChanges = true;
        }.bind(this));

        this.pendingChanges = false;
    },

    methods: {
        emitEventCancel() {
       /* if(this.pendingChanges){
            this.$bvModal.msgBoxConfirm('Do you want to exit without saving the changes?', {
            title: 'Pharmacy Notes',
            okTitle: this.$t('Shared.BtnSave'),
            cancelTitle: this.$t('Shared.BtnDismiss'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                     this.emitCloseEvent= false;
                     this.$emit('close');
                }else{
                    this.saveComments(); 
                }                
            })
        }else{
            this.emitCloseEvent= false;
            this.$emit('close');
        }*/
        this.pendingChanges = false;
        this.emitCloseEvent= false;
        this.$emit('close');
           
        },

        emitEventOK() {
            if (this.validate()) {
                if (this.editable) {
                    this.saveComments();
                } else {
                    this.$emit('ret:comments', this.comments);
                    this.$emit('ok');
                }
            } else {
                if (!this.isValid('comments')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('comments'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
               /* this.$emit('close');
                this.emitCloseEvent= false;*/                
                this.emitEventCancel();
            }
        },

        changeDropDownNoteType(value) {           
            if (value) {
                this.comments = value.name;
                this.pendingChanges = true;
            }
        },

   
        validate() {
            if (!this.editable) {
                const rules = {
                    comments: [
                        validationRules.required(
                            this.$t("PharmacyNotes.NotesRequired")
                        ),
                    ],
                };

                return this.validateFields(rules, {'comments': this.comments});
            }
            
            return true;
        },

        changeDropDownLocation(value) {
            this.value.locationTo = value ? value.code : null;
        },

        loadComments() {
            MedicationService
                .getNotes(this.item.recordId)
                .then((response) => {
                    if(response.status == '200') {
                        this.comments = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        saveComments() {
            MedicationService
                .updateNotes(this.item.recordId, {pharmacistNotes: this.comments })
                .then(() => {
                    this.pendingChanges = false;
                    this.$emit('ok');
                })
                .catch((error) => {
                    this.$emit('ok');
                    this.showResponseErrorMessage(error);
                });
        },

        close() {
            this.emitEventCancel();
        },
        hide(){
            this.emitEventCancel();
        }
    }
}
</script>